import Dialog from '@material-ui/core/Dialog';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import VideoBrowser from '../../videos/List/VideoBrowser';
import { buildEmbedCode } from '../../videos/utils';
import { closeDailymotion } from './Command/actions';
import { selectPlayers } from './selectPlayers';

@connect((store, props) => ({
  open: (store.editor.dailymotion && store.editor.dailymotion.open) || false,
  players: selectPlayers(store.person.detail, props.relatedPersonIds),
}))
@withMobileDialog()
export default class DailymotionModal extends Component {
  handleSelect = videoId => this.props.dispatch(closeDailymotion(buildEmbedCode(videoId)));

  handleClose = () => this.props.dispatch(closeDailymotion(null));

  render() {
    const { open, players, fullScreen } = this.props;

    // The modal is mounted for every editor instance; only render its content
    // while open (keeps the shared video list from mounting needlessly).
    if (!open) {
      return null;
    }

    return (
      <Dialog
        open
        onClose={this.handleClose}
        fullScreen={fullScreen}
        fullWidth
        maxWidth="lg"
        PaperProps={{ style: { minHeight: '70vh' } }}
        data-test="DailymotionModal"
      >
        {/* Modal-only padding so the list isn't glued to the dialog edges (page reuses VideoBrowser without it). */}
        <div style={{ padding: 16 }}>
          <VideoBrowser
            mode="select"
            titleKey="videos_insert_title"
            players={players}
            onSelect={this.handleSelect}
          />
        </div>
      </Dialog>
    );
  }
}
